import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {v4 as uuidV4} from 'uuid';
import serialize from 'form-serialize';
import Button from '@spothero/ui/button';
import Form from '@spothero/ui/form';
import FormElementError from '@spothero/ui/form-element-error';
import FormGroup from '@spothero/ui/form-group';
import FormGroupError from '@spothero/ui/form-group-error';
import Label from '@spothero/ui/label';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import TextInput from '@spothero/ui/text-input';
import ValidationUtils from '@spothero/utils/validation';
import {notify} from 'notification/notification-actions';
import AuthenticationUtils from 'utils/authentication';

class ForgotPasswordModal extends Component {
    static propTypes = {
        onHidden: PropTypes.func.isRequired,
        sendNotification: PropTypes.func.isRequired,
    };
    state = {
        formError: null,
        isLoading: false,
    };

    _onSubmit = evt => {
        const {email} = serialize(evt.target, {hash: true});

        this.setState({
            formError: null,
            isLoading: true,
        });

        AuthenticationUtils.resetPassword(
            email,
            data => {
                this.props.sendNotification({
                    id: uuidV4(),
                    type: 'success',
                    message:
                        'Password reset email sent.  Please check your inbox.',
                });

                this._modal.hide();
            },
            errors => {
                this.setState({
                    formError: {
                        title:
                            'There was an issue resetting your password, please try again.',
                    },
                    isLoading: false,
                });
            }
        );
    };

    render() {
        const {onHidden} = this.props;
        const {isLoading, formError} = this.state;

        return (
            <Modal
                ref={node => {
                    this._modal = node;
                }}
                className="ForgotPasswordModal"
                title="Reset Password"
                onHidden={onHidden}
                width="slim"
            >
                <ModalContent>
                    <Form
                        id="ForgotPasswordModal-form"
                        onSubmit={this._onSubmit}
                    >
                        <FormGroup>
                            <TextInput
                                type="email"
                                name="email"
                                label={<Label>Email</Label>}
                                pattern={ValidationUtils.EMAIL}
                                error={
                                    <FormElementError>
                                        Please enter a valid email.
                                    </FormElementError>
                                }
                                required
                                autoFocus
                            />
                        </FormGroup>
                        <div className="FormActions">
                            <Button
                                type="submit"
                                color="primary"
                                loading={isLoading}
                                disabled={isLoading}
                            >
                                Reset Password
                            </Button>
                        </div>
                        {formError && (
                            <FormGroupError>{formError.title}</FormGroupError>
                        )}
                    </Form>
                </ModalContent>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    sendNotification: notify,
};

export default connect(null, mapDispatchToProps)(ForgotPasswordModal);
